import { createFileRoute } from '@tanstack/react-router'
import { TermsEditor } from '@/features/terms'

export const Route = createFileRoute('/_authenticated/terms/')({
  component: TermsEditor,
})
